module.exports = __webpack_public_path__ + "img/plan02_text01.0072f164.png";